var render, staticRenderFns
import script from "./HKLLeftRight.vue?vue&type=script&lang=js&"
export * from "./HKLLeftRight.vue?vue&type=script&lang=js&"
import style0 from "./HKLLeftRight.vue?vue&type=style&index=0&id=74dee4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dee4d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dee4d1')) {
      api.createRecord('74dee4d1', component.options)
    } else {
      api.reload('74dee4d1', component.options)
    }
    
  }
}
component.options.__file = "src/controls/Layout/HKLLeftRight.vue"
export default component.exports